import { useMemo } from "react";

const useCollectionData = (userData, idCollection) => {
  return useMemo(() => {
    if (!userData || !userData.collection || !idCollection) {
      return [];
    }

    // Accéder à la collection spécifique via idCollection
    const collection = userData.collection[idCollection];

    if (!collection) {
      return [];
    }

    // Transforme la collection en une liste structurée
    return Object.keys(collection).map((cardTitle) => {
      const doublons = collection[cardTitle]?.doublon || 0;

      // Si l'utilisateur possède la carte, "doublons" doit être au moins 1
      return {
        title: cardTitle,
        doublons: doublons > 0 ? doublons : 1, // Si carte présente, au moins 1
      };
    });
  }, [userData, idCollection]);
};

export default useCollectionData;
